// pages/anyMasterPage.tsx

import { useState } from "react";
import { ServiceTable } from "./ServiceTable";
import { AddEditServiceModal } from "./AddEditServiceModal";
import useServiceList from "../../controllers/serviceMaster/useServices";
import utils from "../../Utils";
import HttpClient from "../../lib/HttpClient";
import { useSnackbarContext } from "../../contexts/Snackbar";
import { ConfirmDialog } from "./ConfirmDialog";

export default function ServiceMaster() {
  const { setSnackbar } = useSnackbarContext();

  const { services, isLoading, refresh: refreshServices } = useServiceList();

  const receptionistProfile = utils.retrieveUserProfile();

  const [selectedService, setSelectedService] = useState<any | null>(null);
  const [deleteTarget, setDeleteTarget] = useState<any | null>(null);

  const [showModal, setShowModal] = useState(false);

  const handleAdd = () => {
    setSelectedService(null);
    setShowModal(true);
  };

  const handleEdit = (service: any) => {
    setSelectedService(service);
    setShowModal(true);
  };

  const handleDelete = (service: any) => {
    setDeleteTarget(service); // open dialog
  };
  const handleSave = async (serviceData: any) => {
    const clinicId = receptionistProfile.clinicId;
    try {
      const url = selectedService
        ? `/api/v1/clinics/${clinicId}/services/${selectedService.id}`
        : `/api/v1/clinics/${clinicId}/services`;

      const response = selectedService
        ? await HttpClient.performPut<any>(url, serviceData)
        : await HttpClient.performPost<any>(url, serviceData);

      if (!response?.body?.status?.success) {
        setSnackbar({
          message: response?.body?.status?.message || "Failed to save service",
          severity: "error",
        });
        return;
      }

      setSnackbar({
        message: selectedService
          ? "Service updated successfully!"
          : "Service created successfully!",
        severity: "success",
      });

      await refreshServices();
      setShowModal(false);
      setSelectedService(null);
    } catch (err) {
      setSnackbar({
        message: "Something went wrong",
        severity: "error",
      });
    } finally {
    }
  };

  const confirmDelete = async () => {
    if (!deleteTarget?.id) return;
    const clinicId = receptionistProfile.clinicId;

    try {
      const url = `/api/v1/clinics/${clinicId}/services/${deleteTarget.id}`;

      const response = await HttpClient.performDelete<any>(url);

      if (!response?.body?.status?.success) {
        setSnackbar({
          message:
            response?.body?.status?.message || "Failed to delete service",
          severity: "error",
        });
        return;
      }

      setSnackbar({
        message: "Service deleted successfully!",
        severity: "success",
      });

      await refreshServices();
      setDeleteTarget(null);
    } catch (err) {
      setSnackbar({
        message: "Something went wrong",
        severity: "error",
      });
    } finally {
    }
  };

  return (
    <div className="container py-4 mt-5 pt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-semibold mb-0">Service & Price Master</h4>

        <button
          className="btn  px-3"
          style={{ backgroundColor: "var(--darkbluecolorone)", color: "white" }}
          onClick={handleAdd}
        >
          + Add Service
        </button>
      </div>

      <ServiceTable
        services={services || []}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {showModal && (
        <AddEditServiceModal
          service={selectedService}
          onClose={() => setShowModal(false)}
          onSave={handleSave}
        />
      )}

      {deleteTarget && (
        <ConfirmDialog
          open={Boolean(deleteTarget)}
          title="Delete Service"
          confirmText="Delete"
          message={
            <>
              Are you sure you want to delete{" "}
              <strong>{deleteTarget?.name}</strong>?
              <br />
              This action cannot be undone.
            </>
          }
          onClose={() => setDeleteTarget(null)}
          onConfirm={confirmDelete}
        />
      )}
    </div>
  );
}
